import type { Deal } from '~/models/Deal';
import type { Leasing } from '~/models/Leasing';
import type { PropertyBuildingOption } from '~/models/PropertyBuildingOption';
import type { PropertyRoomOption } from '~/models/PropertyRoomOption';

export type PropertyType = 'room' | 'building' | 'parking_space' | 'parking';
export type Property<T extends PropertyType> = {
  type: T;
  propertyId: number;
  name: string;
  roomNumber: T extends 'room' | 'parking_space' ? string : null;
  zipcode: string;
  address: string;
};

export const buildPropertyByDeal = (
  deal: Deal
): Property<PropertyType> | null => {
  if (deal.propertyType === null || deal.propertyId === null) return null;
  return {
    type: deal.propertyType,
    propertyId: deal.propertyId,
    name: deal.name,
    roomNumber: deal.roomNumber,
    zipcode: '',
    address: deal.address
  };
};

export const buildPropertyByLeasing = (
  leasing: Leasing
): Property<PropertyType> | null => {
  if (leasing.amaterasPropertyId === null) return null;
  return {
    type: leasing.amaterasPropertyType ?? 'room',
    propertyId: leasing.amaterasPropertyId,
    name: leasing.roomName ?? '',
    roomNumber: leasing.roomNumber,
    zipcode: '', // NSKDEV-1776 で追加予定
    address: leasing.address ?? ''
  };
};

export const buildPropertyByPropertyRoomOption = (
  propertyOption: PropertyRoomOption | null
): Property<'room'> | null => {
  if (propertyOption === null || propertyOption.amaterasPropertyId === null)
    return null;
  return {
    type: 'room',
    propertyId: propertyOption.amaterasPropertyId,
    name: propertyOption.name,
    roomNumber: propertyOption.roomNumber ?? '',
    zipcode: '',
    address: propertyOption.address
  };
};

export const buildPropertyByPropertyBuildingOption = (
  propertyOption: PropertyBuildingOption | null
): Property<'building'> | null => {
  if (propertyOption === null || propertyOption.amaterasPropertyId === null)
    return null;
  return {
    type: 'building',
    propertyId: propertyOption.amaterasPropertyId,
    name: propertyOption.name,
    roomNumber: null,
    zipcode: '',
    address: propertyOption.address
  };
};
